import React, {useMemo} from "react"
import nprogress from "nprogress"
import useAuth from "auth/useAuth"
import useAreas from "hooks/useAreas"
import useShifts from "hooks/useShifts"
import useShiftPermissions from "hooks/useShiftPermissions"
import Shift from "./Shift"
import "./ShiftPage.css"

export default function ShiftPage() {

    const {auth, API, username, admin} = useAuth()
    const {area, setArea, mountains} = useAreas()
    const shifts = useShifts()
    const shift = shifts.get(area)
    const {permissions} = useShiftPermissions(area)
    
        
    const addRescuer = (rescuer) => {
        nprogress.start()
        auth(API.shiftsAreaRescuersRescuerPost, {area, rescuer: rescuer.username}).then(response => {
            shifts.refetch()
            nprogress.done()
        })
    }
    
    const removeRescuer = (rescuer) => {
        nprogress.start()
        auth(API.shiftsAreaRescuersRescuerDelete, {area, rescuer: rescuer.username}).then(response => {
            shifts.refetch()
            nprogress.done()
        })
    }
    
    
    const setHead = (rescuer) => {
        nprogress.start()
        auth(API.shiftsAreaHeadRescuerPost, {area, rescuer: rescuer.username}).then(response => {
            shifts.refetch()
            nprogress.done()
    	})
    }

    const shiftActions = useMemo(() => ({
        add: addRescuer,
        remove: removeRescuer,
        setHead: setHead
    }), [addRescuer, removeRescuer, setHead])

    return <div id="shift-page" className="container-fluid white shadow">
        <section id="select-area" className="white page-head">
            <h3>Smena</h3>
            <select onChange={event => setArea(event.target.value)} value={area}>
                {mountains.map(key => <option key={key} value={key}>{key}</option>)}
            </select>
        </section>

        {shifts.isLoading && <>
            <div id="spinner" className="center"/>
            <div id="clear"/>
        </>}

        {shift && <Shift shift={shift} actions={shiftActions} permissions={permissions}/>}
    </div>

}
